import { TFunction } from '@lyearn/i18n';
import { StatusPillAppearance } from '@lyearn/ui/dist/esm/Pill/StatusPill/types';
import { BaseCardContent } from '@/modules/content/components/ContentCard/BaseCard/types';
import { getOverdue } from '@/modules/content/components/ContentCard/utils/getOverdue';
import {
  Content,
  ContentOverdueDueEnum,
} from '@/modules/content/components/ContentCard/utils/types';

const STATUS_APPEARANCE_CONFIG: { [key in ContentOverdueDueEnum]: StatusPillAppearance } = {
  [ContentOverdueDueEnum.Due]: 'cyan',
  [ContentOverdueDueEnum.Overdue]: 'danger',
  [ContentOverdueDueEnum.Completed]: 'success',
  [ContentOverdueDueEnum.DueShort]: 'cyan',
};

export const getContentCardStatus = (t: TFunction, content: Content) => {
  let status: BaseCardContent['status'];
  const overdue = getOverdue(t, content);

  if (overdue) {
    status = { label: overdue.label, appearance: STATUS_APPEARANCE_CONFIG[overdue.status] };
  }

  return status;
};
